module.exports = __webpack_public_path__ + "static/couture03-sq-3b80caead027dd96caed49427b257fbe.png";